import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const TagIcon = (props: IconProps) => (
  <ChakraIcon viewBox="13.00 13.00 37.00 37.00" {...props}>
    <path d="M31.4671,49 C21,48.4852941 21,39.7352941 21,39.7352941 L21,23.2647059 C21,23.2647059 21,14 31.5,14 C42,14 42,23.2647059 42,23.2647059 L42,39.7352941 C42,39.7352941 42,49 31.4671,49 L31.4671,49 Z M31.5,18.150641 C28.5083963,18.150641 26.080428,20.531002 26.080428,23.4639469 C26.080428,26.3968917 28.5083963,28.7772527 31.5,28.7772527 C34.4916037,28.7772527 36.919572,26.3968917 36.919572,23.4639469 C36.919572,20.531002 34.4916037,18.150641 31.5,18.150641 L31.5,18.150641 Z" fill="currentColor" transform="translate(31.5, 31.5) rotate(45) translate(-31.5, -31.5)" fillRule="evenodd" />
  </ChakraIcon>
)

export default TagIcon
